const TotalWalletConnectedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.0278 7.75487C19.0278 5.92726 17.5463 4.44569 15.7187 4.44569C15.7187 3.07498 14.6075 1.96381 13.2368 1.96381H4.55017C3.40791 1.96381 2.48193 2.88979 2.48193 4.03204C2.48193 4.11798 2.48718 4.2027 2.49736 4.28588C2.48724 4.33759 2.48193 4.39102 2.48193 4.44569V15.2005C2.48193 17.0281 3.9635 18.5097 5.79111 18.5097H15.7187C17.5463 18.5097 19.0278 17.0281 19.0278 15.2005V7.75487ZM4.551 4.44565H14.0649C14.0649 3.98875 13.6945 3.61836 13.2376 3.61836H4.551C4.32255 3.61836 4.13735 3.80356 4.13735 4.03201C4.13735 4.26046 4.32255 4.44565 4.551 4.44565ZM14.8922 14.3732H17.3741V15.2005C17.3741 16.1143 16.6333 16.8551 15.7195 16.8551H5.79194C4.87814 16.8551 4.13735 16.1143 4.13735 15.2005V6.05888C4.271 6.08601 4.40934 6.10025 4.551 6.10025H15.7195C16.6333 6.10025 17.3741 6.84103 17.3741 7.75484V9.40943H14.8922C13.5215 9.40943 12.4103 10.5206 12.4103 11.8913C12.4103 13.262 13.5215 14.3732 14.8922 14.3732ZM17.3745 11.064V12.7186H14.8926C14.4357 12.7186 14.0653 12.3482 14.0653 11.8913C14.0653 11.4344 14.4357 11.064 14.8926 11.064H17.3745Z"
      fill="white"
    />
  </svg>
);

export default TotalWalletConnectedIcon
